import { ReactElement } from 'react'
import styled, { ThemeProvider } from 'styled-components'

import { CancelIcon } from 'components/Icons/CancelIcon'
import Heading from 'components/v2/Heading'
import { ITagProps, ITheme } from './types'

const ChipContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }): string => theme.backgroundColor};
  border: 1px solid ${({ theme }): string => theme.borderColor};
  border-radius: 24px;
  display: inline-flex;
  gap: 10px;
  padding: 3.5px 8px;
  transition: 0.3s;
  width: fit-content;
  max-width: calc(100% - 18px);

  svg {
    cursor: pointer;
    fill: ${({ theme }): string => theme.color};
    height: 16px;
    width: 16px;
    min-width: 16px;
  }
`

const ChipText = styled.div`
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

const IconWrapper = styled.div`
  display: flex;
  cursor: pointer;
  svg {
    fill: ${({ theme }): string => theme.iconColor};
  }
`

const theme: ITheme = {
  primary: {
    backgroundColor: '#E0D6FF',
    borderColor: '#E0D6FF',
    color: '#28265D',
    iconColor: '#916EE8'
  },
  default: {
    backgroundColor: '#F0F0F0',
    borderColor: '#F0F0F0',
    color: '#B0B0B0'
  }
}

const Tag = ({ className, children, state = 'primary', onDelete, isDeleteDisabled }: ITagProps): ReactElement => {
  const tagState = isDeleteDisabled ? 'default' : state

  return (
    <ThemeProvider theme={theme[tagState]}>
      <ChipContainer className={className}>
        <ChipText>
          <Heading.Body style={{ color: tagState === 'default' ? '#B0B0B0' : '' }}>{children}</Heading.Body>
        </ChipText>
        {onDelete && !isDeleteDisabled ? (
          <IconWrapper onClick={onDelete}>
            <CancelIcon />
          </IconWrapper>
        ) : null}
      </ChipContainer>
    </ThemeProvider>
  )
}

export { Tag }
